/* Dreamlet Stories library: filters, Club panel and checkout, continue reading, surprise me, remote navigation. */
(function () {
  'use strict';
  var root = document.getElementById('dl');
  if (!root) return;
  var store = {
    get: function (k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); };

  // Sign-in links come back to exactly this page. /account/login?return_url= works for both classic and new
  // customer accounts (Shopify forwards it to its sign-in page as return_to).
  var back = location.pathname + location.search;
  $$('[data-login]').forEach(function (a) { a.href = '/account/login?return_url=' + encodeURIComponent(back); });

  // Toast
  var toast = document.getElementById('dl-toast'), toastT = null;
  function say(msg) { toast.textContent = msg; toast.hidden = false; clearTimeout(toastT); toastT = setTimeout(function () { toast.hidden = true; }, 2600); }

  // Age filter (remembered on this device)
  var chips = $$('.dl-chip');
  function applyAge(age) {
    chips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-age') === age ? 'true' : 'false'); });
    $$('.dl-book').forEach(function (b) { b.hidden = !(age === 'all' || b.getAttribute('data-age') === age); });
    store.set('dreamlet.age', age);
  }
  chips.forEach(function (c) { c.addEventListener('click', function () { applyAge(c.getAttribute('data-age')); }); });
  applyAge(store.get('dreamlet.age') || 'all');

  // Unlock / sign-in panels
  var lastFocus = null;
  function openSheet(handle) {
    var sheet = document.getElementById('dl-sheet-' + handle);
    if (!sheet) return;
    lastFocus = document.activeElement;
    sheet.hidden = false;
    var first = sheet.querySelector('a, button:not([data-close])') || sheet.querySelector('[data-close]');
    if (first) first.focus();
  }
  function closeSheets() {
    $$('.dl-sheet').forEach(function (s) { s.hidden = true; });
    if (lastFocus) lastFocus.focus();
  }
  $$('[data-unlock]').forEach(function (b) { b.addEventListener('click', function () { openSheet(b.getAttribute('data-unlock')); }); });
  $$('[data-close]').forEach(function (b) { b.addEventListener('click', closeSheets); });
  $$('.dl-sheet').forEach(function (s) { s.addEventListener('click', function (e) { if (e.target === s) closeSheets(); }); });
  if (location.hash === '#club') openSheet('club');   // "Join the Club" links from the story pages

  // Dreamlet Stories Club: put the chosen plan (monthly or yearly) in the cart and go straight to checkout.
  // If anything fails, the product page opens with that plan selected instead.
  $$('[data-join]').forEach(function (b) { b.addEventListener('click', function () {
    var variant = Number(b.getAttribute('data-variant')), plan = Number(b.getAttribute('data-plan'));
    var fallback = b.getAttribute('data-fallback');
    var clubIds = $$('[data-join]').map(function (x) { return Number(x.getAttribute('data-variant')); });
    var json = function (r) { if (!r.ok) throw new Error(r.status); return r.json(); };
    var post = function (url, body) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(json);
    };
    b.disabled = true; b.classList.add('dl-plan-busy');
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(json).then(function (cart) {
      // never two Club plans in one cart (e.g. after tapping Monthly, going back and choosing Yearly)
      return cart.items.filter(function (i) { return clubIds.indexOf(i.variant_id) >= 0; }).reduce(function (p, i) {
        return p.then(function () { return post('/cart/change.js', { id: i.key, quantity: 0 }); });
      }, Promise.resolve());
    }).then(function () {
      return post('/cart/add.js', { items: [{ id: variant, quantity: 1, selling_plan: plan }] });
    }).then(function () { location.href = '/checkout'; }, function () { location.href = fallback; });
  }); });

  $$('.dl-book-soon').forEach(function (b) { b.addEventListener('click', function () {
    var when = b.getAttribute('data-soon') || 'soon';
    say(/^coming/i.test(when) ? when + '.' : 'This story arrives ' + when + '.');
  }); });

  // Continue reading / tonight's story (the reader saves progress in dreamlet.progress)
  var open = $$('.dl-book[data-open="1"]');
  var card = document.getElementById('dl-continue');
  function visibleOpen() { return open.filter(function (b) { return !b.hidden; }); }
  if (card && open.length) {
    var p = store.get('dreamlet.progress');
    var pick = null, label = 'Read', eyebrow = "Tonight's story", meta = '';
    if (p && p.view && !p.done) {
      pick = open.filter(function (b) { return b.getAttribute('data-view') === p.view; })[0] || null;
      if (pick && p.page > 1) {
        eyebrow = 'Continue reading'; label = 'Continue';
        meta = 'Page ' + p.page + ' of ' + p.total;
        var bar = document.getElementById('dl-continue-bar');
        bar.hidden = false; bar.firstElementChild.style.width = Math.round(p.page / p.total * 100) + '%';
      }
    }
    if (!pick) {
      var lastView = p && p.view;
      var pool = open.filter(function (b) { return b.getAttribute('data-view') !== lastView; });
      pick = (pool.length ? pool : open)[new Date().getDate() % (pool.length || open.length)];
    }
    if (!meta) meta = (pick.getAttribute('data-minutes') ? pick.getAttribute('data-minutes') + ' minutes · ' : '') + 'read aloud, with soft music if you like';
    document.getElementById('dl-continue-eyebrow').textContent = eyebrow;
    document.getElementById('dl-continue-title').textContent = pick.getAttribute('data-title');
    document.getElementById('dl-continue-meta').textContent = meta;
    document.getElementById('dl-continue-label').textContent = label;
    var go = document.getElementById('dl-continue-go');
    go.href = pick.getAttribute('href') + (label === 'Continue' ? '&page=' + p.page : '');
    var img = pick.querySelector('.dl-cover img');
    var hero = document.getElementById('dl-continue-img');
    if (p && p.view === pick.getAttribute('data-view') && p.art) hero.src = p.art;
    else if (!hero.getAttribute('src') && img) hero.src = img.src;
    card.hidden = false;
  }
  var surprise = document.getElementById('dl-surprise');
  if (surprise) surprise.addEventListener('click', function () {
    var pool = visibleOpen(); if (!pool.length) pool = open;
    if (pool.length) location.href = pool[Math.floor(Math.random() * pool.length)].getAttribute('href');
  });

  // Full screen (handy on the projector)
  var fs = document.getElementById('dl-fs');
  if (fs) fs.addEventListener('click', function () {
    if (window.DreamletScreen) { DreamletScreen.toggle(); return; }   // iPhone: explains Add to Home Screen
    var d = document.documentElement;
    if (!document.fullscreenElement && !document.webkitFullscreenElement) (d.requestFullscreen || d.webkitRequestFullscreen || function () {}).call(d);
    else (document.exitFullscreen || document.webkitExitFullscreen || function () {}).call(document);
  });

  // Remote control: arrow keys move focus to the nearest item in that direction; Escape closes panels.
  function focusables() {
    var scope = $$('.dl-sheet').filter(function (s) { return !s.hidden; })[0] || root;
    return $$('a[href], button:not([disabled]), input', scope).filter(function (el) {
      if (el.closest('[hidden]')) return false;
      var r = el.getBoundingClientRect(); return r.width > 0 && r.height > 0;
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeSheets(); return; }
    var dir = { ArrowRight: [1, 0], ArrowLeft: [-1, 0], ArrowDown: [0, 1], ArrowUp: [0, -1] }[e.key];
    if (!dir || (e.target && e.target.tagName === 'INPUT')) return;
    var cur = document.activeElement, items = focusables();
    if (!cur || items.indexOf(cur) < 0) { if (items[0]) { items[0].focus(); e.preventDefault(); } return; }
    var a = cur.getBoundingClientRect(), ax = a.left + a.width / 2, ay = a.top + a.height / 2, best = null, bestScore = Infinity;
    items.forEach(function (el) {
      if (el === cur) return;
      var b = el.getBoundingClientRect(), dx = b.left + b.width / 2 - ax, dy = b.top + b.height / 2 - ay;
      var along = dx * dir[0] + dy * dir[1];
      if (along <= 4) return;
      var across = Math.abs(dx * dir[1]) + Math.abs(dy * dir[0]);
      var score = along + across * 2.5;
      if (score < bestScore) { bestScore = score; best = el; }
    });
    if (best) {
      e.preventDefault(); best.focus();
      best.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }
  });

  // ?debug=1 shows what the page detected for the signed-in customer (only their own data).
  if (/[?&]debug=1/.test(location.search)) {
    var d = document.getElementById('dl-debug');
    d.hidden = false;
    d.textContent = 'Signed in: ' + (root.getAttribute('data-signed-in') === '1' ? 'yes' : 'no') +
      '\nAccess: ' + (root.getAttribute('data-access') || '(none)') +
      '\nClub member: ' + (/,(member|all),/.test(root.getAttribute('data-access') || '') ? 'yes' : 'no') +
      '\nOpen stories: ' + open.map(function (b) { return b.getAttribute('data-view'); }).join(', ');
  }
})();
